
import { Component, AfterViewInit,ViewChild, OnDestroy, Input, OnChanges } from '@angular/core';
import { UserManager } from '../../Services/UserManager/user-manager';
import { Profile } from '../../Models/profile.interface'
import { AngularFireDatabase } from '@angular/fire/database';
import { trigger, state, style , animate, transition  } from '@angular/animations';
import { LessonManagerService } from '../../Services/LessonManager/lesson-manager.service'
import { LessonCard } from '../../Models/lessons.interface';
import { Subject } from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import _ from 'lodash';
import { AngularFirestore } from '@angular/fire/firestore';
import { PROFILES } from 'src/Constants';
import { Confirmation } from 'src/app/Models/Confirmation.interface';
import { ContactSheetComponent } from 'src/app/components/contact-sheet/contact-sheet.component';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ProfileSheetComponent } from 'src/app/components/profile-sheet/profile-sheet.component';

@Component({
  selector: 'app-admin-contacts',
  templateUrl: './admin-contacts.component.html',
  styleUrls: ['./admin-contacts.component.css'],
  animations: [
    trigger('display', [

        state('void', style({
            opacity: 0,
            display: 'none'

        })),
        state('show', style({
          opacity: 1,
          // transform: 'scale(2)'
      })),
      transition('* => *',[ animate('200ms  ease-in-out')]),
    ])
    ]
})
export class AdminContactsComponent implements AfterViewInit, OnDestroy {
  @Input() superAdmin: boolean
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  profile: Profile;
  users: MatTableDataSource<DisplayUser>
  unsortedUsers: Array<DisplayUser>
  groups = {}
  keys = Array<string>()
  triggeredUsers =  Array<DisplayUser>()
  current: number = 0
  view: string = 'list'
  order: string = 'lessons' // lastUpdated, anonymous
  search: string = ""
  instructors: Array<Profile>
  leaving = new Subject<null>()
  change = new Subject()
  instrigger = 'void'
  lastOrderedResult = []
  confs = [
    17,18,19,15,19,17,18,19,17,18,20,17,19,16,17,15,20,14,17,17,17,19,21,17,19
  ]
  limit = 5000
  offset = 0
  cards = Array<LessonCard>()
  questions = [ "The Bible demonstrates that God can be trusted. Are you willing to tell God you trust Him, and that you would like to know more about Him and His plan for your life?" ,
  "Is it your desire to prepare now to be ready for the Second Coming of Jesus? Will you ask Jesus now to be your personal Savior and trust Him to guide and direct your life?" ,
  "Are you willing to choose to have faith in Jesus, and to stand with Him in the great battle between good and evil?" ,
  "Jesus offers you the free gift of salvation.  Will you invite Jesus into your life today, accept Him as your Savior, and allow Him to live His life in you?" ,
  "Would you be willing to surrender your life to Jesus now, and ask Him to live His life in you? , Are you willing today to invite Jesus to live His life in you, and to guide you in a life of loving obedience to God?" ,
  "Out of love for God, are you willing to remember the Sabbath day and keep it holy?" ,
  "Are you willing to worship God in spirit and truth, and observe the seventh-day Sabbath of the Bible?" ,
  "Are you willing to make a complete surrender to God, and ask that His will - and not your will - be done in your life?" ,
  "Are you willing to put your faith in Jesus - the Resurrection and the Life - and trust Him to be your Lord and Savior?" ,
  "All who accept Jesus by faith can anticipate living one day at with God in an earth made new.  Are you willing to accept Jesus today as your personal Savior, and are you looking forward to living with Jesus on a re-created earth?" ,
  "Are you willing to accept the gift of salvation from Jesus today, and are you looking forward to eternity in a world without sin and sadness?" ,
  "Are you willing to surrender your life to Jesus, invite Him into your heart and live by faith in Jesus in preparation for His return?" ,
  "Is it your desire to follow the example of Jesus, have a fresh start in life and begin preparing for your baptism according to the Bible?" ,
  "Are you willing to surrender your life to God and accept His principles for better physical and spiritual health?" ,
  "Would you like to accept the forgiveness and power offered you by your heavenly High Priest, ministering for you now in the heavenly sanctuary?" ,
  "Are you willing to commit your life to Jesus today?" ,
  "Are you willing to follow Jesus wherever He leads, and allow the Bible to be the basis for your faith in Him?" ,
  "Would you like to prepare for the seal of God by keeping all of God's commandments, including the Sabbath, as a sign that you will follow Jesus wherever He leads?" ,
  "Are you willing to yield your life to Jesus, and - by His power - live a life committed to Him and His Word?" ,
  "Jesus loves you, and He is calling you to join Him within God's end-time church.  Is it your decision to follow Jesus according to the teachings of the Bible and become a part of sharing God's final message with the world?" ,
  "Are you willing to come out of Babylon, and to allow God to lead you in harmony with the truth of His Word?" ,
  "Are you willing to embrace the genuine gift of prophecy, and allow God to guide you in your understanding of this special end-time blessing?" ,
  "Are you willing to trust God, and in faith return 10 percent to Him?" ,
  "Are you willing to receive the Holy Spirit?  Do you desire to be equipped to serve God, and to be made like Jesus?" ]

  
  constructor(
    private um: UserManager,
    private afs: AngularFirestore,
    private _bottomSheet: MatBottomSheet,
    private lm: LessonManagerService ) { 
   this.cards =  this.lm.getLessonCards()
  }

  ngAfterViewInit() {
      // console.log(this.orgId, this.entityId)

    if(this.superAdmin){
      this.getUsers()
    }
      

  }
  ngOnDestroy(){
    this.leaving.next(null)
  }


  toggleInstructors(){
    this.instrigger = this.instrigger === 'show' ? 'void' : 'show'
  }


  tracked(item, s){
    return s
  }
  tracked2(item, s){
    return s
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.users.filter = filterValue.trim().toLowerCase();

    if (this.users.paginator) {
      this.users.paginator.firstPage();
    }
  }

  openContactSheet(event, contact): void {
    event.stopPropagation();
    this._bottomSheet.open(ContactSheetComponent, {
      data: { 
        contact,
        openProfileSheet: this.openProfileSheet
      }
    });
  }
  openProfileSheet(event, row): void {
    event.stopPropagation();
    // console.log(row)
    this._bottomSheet.open(ProfileSheetComponent, {
      data: { 
        profile: row.profile
      }
    });
  }



  getUsers(){
    this.afs.collection<Profile>(PROFILES, ref => ref
    .limit(this.limit)
    .orderBy('createdAt', 'desc'))
    .valueChanges()
    .takeUntil(this.leaving)
    .takeUntil(this.change)
    .subscribe(users => {  
      for(let user of users){
        if(!this.groups[user.currentLesson]){  
            this.groups[user.currentLesson] = Array<Profile>()       
          }
        this.groups[user.currentLesson].push(user)
      }
      
      const _users = _.map(users, user => {
        let u = {} as DisplayUser
        u.profile = user
        u.trigger = 'void'
        u.firstname = user?.firstname || ''
        u.lastname = user?.lastname || ''
        u.lastUpdated = user?.lastUpdated
        u.entityId = user?.entityId
        u.createdAt = user?.createdAt

        return u
      })
      this.users = new MatTableDataSource(_users)
      this.users.paginator = this.paginator;
      this.users.sort = this.sort;
      this.unsortedUsers = _.cloneDeep(_users)

    })

  }

  toggleUser(user: DisplayUser){
    if(user.trigger === 'void'){
      user.trigger = 'expanded'
      this.current = user.profile.currentLesson
    } else {
      user.trigger = 'void'
    }
    for(let u of this.triggeredUsers){
      if(u !== user){
        u.trigger = 'void'
      }
    }
    this.triggeredUsers = []
    this.triggeredUsers.push(user)

  }
}

interface DisplayUser {
  // profile: Profile
  firstname: string
  lastname: string
  profile: Profile
  trigger: string
  entityId: string
  lastUpdated: any
  createdAt: number
}


